import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { setTieuChuanHocSinhApi } from "../../../api/set-tieu-chuan/setTieuChuanHocSinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ISetTieuChuanHocSinh } from "../../../model/respone/set-tieu-chuan/ISetTieuChuanHocSinh";
import { eSetTieuChuanHocSinhActionTypeIds, ISetTieuChuanHocSinhActions } from "../../action-types/set-tieu-chuan/ISetTieuChuanHocSinhActions";
import { rootActions } from "../../actions/rootActions";
import { IHocSinhComboRequest } from "../../../model/request/set-tieu-chuan/IHocSinhComboRequest";
import { IHocSinhSelectRequest } from "../../../model/request/set-tieu-chuan/IHocSinhSelectRequest";
import { ICommonRequest } from "../../../model/request/ICommonRequest";

const mainAction = rootActions.setTieuChuan.hocSinh;

export function* setTieuChuanHocSinhSaga(): any {
    yield takeLatest(eSetTieuChuanHocSinhActionTypeIds.LOAD_START, loadWorker);
    yield takeEvery(eSetTieuChuanHocSinhActionTypeIds.SAVE_START, saveWorker);
    yield takeEvery(eSetTieuChuanHocSinhActionTypeIds.DELETE_START, deleteWorker);
    yield takeEvery(eSetTieuChuanHocSinhActionTypeIds.UPDATE_PHAT_DONG_PHUC_START, updatePhatDongPhucWorker);
    yield takeEvery(eSetTieuChuanHocSinhActionTypeIds.SAVE_ADD_COMBO_START, saveAddComboWorker);
    yield takeLatest(eSetTieuChuanHocSinhActionTypeIds.LOAD_HOCSINH_START, loadHocSinhWorker);
    yield takeLatest(eSetTieuChuanHocSinhActionTypeIds.LOAD_COMBO_PENDING_START, loadComboPendingWorker);
    yield takeEvery(eSetTieuChuanHocSinhActionTypeIds.GET_HTML_PRINT_START, getHtmlPrintWorker);

}

function* loadWorker(action: ISetTieuChuanHocSinhActions): any {

    const res: IBaseRespone = yield call(setTieuChuanHocSinhApi.SelectAll, action.payload as ICommonRequest);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: ISetTieuChuanHocSinhActions): any {
    let res: IBaseRespone;
    const setTieuChuanHocSinh = action.payload as ISetTieuChuanHocSinh;
    if (setTieuChuanHocSinh.id > 0) {
        res = yield call(setTieuChuanHocSinhApi.Update, setTieuChuanHocSinh);
    } else {
        res = yield call(setTieuChuanHocSinhApi.Insert, setTieuChuanHocSinh);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: ISetTieuChuanHocSinhActions): any {
    const res: IBaseRespone = yield call(setTieuChuanHocSinhApi.Delete, action.payload as number);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updatePhatDongPhucWorker(action: ISetTieuChuanHocSinhActions): any {
    const { id, daPhatDongPhuc } = action.payload as { id: number, daPhatDongPhuc: boolean };
    const res: IBaseRespone = yield call(setTieuChuanHocSinhApi.UpdatePhatDongPhuc, id, daPhatDongPhuc);
    if (res.is_success) {
        yield put(mainAction.UPDATE_PHAT_DONG_PHUC_SUCCESS(res.data));
    } else {
        yield put(mainAction.UPDATE_PHAT_DONG_PHUC_ERROR(res.message ?? "Có lỗi"));
    }
}
function* saveAddComboWorker(action: ISetTieuChuanHocSinhActions): any {
    let res: IBaseRespone;
    const request = action.payload as IHocSinhComboRequest;
    res = yield call(setTieuChuanHocSinhApi.InsertCombo, request);
    if (res.is_success) {
        yield put(mainAction.SAVE_ADD_COMBO_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ADD_COMBO_ERROR(res.message ?? "Có lỗi"));
    }
}
function* loadHocSinhWorker(action: ISetTieuChuanHocSinhActions): any {
    const request = action.payload as IHocSinhSelectRequest;

    const res: IBaseRespone = yield call(setTieuChuanHocSinhApi.SelectDanhSachHocSinh, request);
    if (res.is_success) {
        yield put(mainAction.LOAD_HOCSINH_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_HOCSINH_ERROR(res.message ?? "Có lỗi"));
    }
}
function* loadComboPendingWorker(action: ISetTieuChuanHocSinhActions): any {
    const res: IBaseRespone = yield call(setTieuChuanHocSinhApi.SelectAllPending, action.payload as number);
    if (res.is_success) {
        yield put(mainAction.LOAD_COMBO_PENDING_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_COMBO_PENDING_ERROR(res.message ?? "Có lỗi"));
    }
}

function* getHtmlPrintWorker(action: ISetTieuChuanHocSinhActions): any {
    const id = action.payload as number;
    const res: IBaseRespone = yield call(setTieuChuanHocSinhApi.GetHtmlPrint, id);
    if (res.is_success) {
        yield put(mainAction.GET_HTML_PRINT_SUCCESS({
            id,
            data: res.data,
        }));
    } else {
        yield put(mainAction.GET_HTML_PRINT_ERROR({
            id,
            data: res.message ?? "Có lỗi",
        }));
    }
}